<template>
  <div>
    <page-header
      left-side-class="col-12 col-md-7"
      :page="headerConfig"
      right-side-class="col-12 col-md-5"
      class="mt-3 mt-md-0"
      @onReturn="() => $router.back()"
      :has-return="true"
    />
    <filter-manager
      :display-advanced="false"
      class="search-bar"
      search-icon="fa fa-sync"
      search-text="Procesar"
      search-container-class="btn-process"
      v-model="model.search.filters"
      :filters="filterManagerConfig"
      @search="onHandlerSearch"
      ref="filterRef"
    />
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import ProviderServices from '@/services/api/provider.api'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@/modules/report/document'
import FilterManager from 'FilterManager'
import AcademicYearServices from '@/services/api/academicyear.api'
import CodeServices from '@/services/api/code.api'
import ROLE from '@/utils/role'

export default {
  name: 'EligibleStudentsbyEntityMain',
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    model: {
      search: {
        collections: {
          academicYears: [],
          providers: [],
          months: [],
          determinationTypes: [],
        },
        filters: {
          academicYear: null,
          provider: null,
          month: null,
          determinationType: null,
        },
      },
    },
  }),
  computed: {
    headerConfig() {
      return {
        title: 'Estudiantes Elegibles por Entidad',
        icon:
          'fa-solid fa-magnifying-glass-chart pr-0 font-22 magnifying-glass-icon-m ',
        routes: ['Inicio', 'Estudiantes Elegibles por Entidad'],
      }
    },
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'description',
          label: 'Año Académico',
          placeholder: 'Seleccionar',
          error: 'El año académico es requerido.',
          validations: 'required',
          clearable: false,
          class: 'col-12 col-md-3',
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
          onChanged: this.onChangeAcademicYear,
        },
        {
          name: 'provider',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Institución',
          placeholder: 'Seleccionar',
          options: this.model.search.collections.providers,
          value: this.model.search.filters.provider,
          class: 'col-12 col-md-3',
          error: 'El proveedor es requerido.',
          validations: null,
        },
        {
          name: 'month',
          component: 'custom-drop-down',
          class: 'col-12 col-md-3',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Mes',
          placeholder: 'Mes',
          error: 'El mes es requerido.',
          validations: 'required',
          options: this.model.search.collections.months,
          value: this.model.search.filters.month,
        },
        {
          name: 'determinationType',
          component: 'custom-drop-down',
          class: 'col-12 col-md-3',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Tipo de Determinación',
          placeholder: 'Seleccione',
          options: this.model.search.collections.determinationTypes,
          value: this.model.search.filters.determinationType,
        },
      ]
    },
    isAdmin() {
      return this.userRole == ROLE.Administrador;
    },
  },
  async mounted() {
    await this.setFilters();
  },
  methods: {
    hasValue(param) {
      return param !== null && param !== undefined
    },
    async setFilters() {
      const { data: years } = await AcademicYearServices.getCurrentYearAcademicYears();
      this.model.search.collections.academicYears = [...years];
      this.model.search.filters.academicYear = years[0];
      await this.onChangeAcademicYear();

      const { data: determinationTypes } = await CodeServices.getTapRequestDeterminationTypes();
      this.model.search.collections.determinationTypes = [...determinationTypes];
    },
    async onChangeAcademicYear() {
      this.model.search.filters.provider = null
      this.model.search.filters.specialist = null
      this.model.search.filters.specialty = null
      await this.getProvider()
      await this.getMonthsInAcademicYear()
    },
    async getProvider() {
      await ProviderServices.getEligibleStudentProviders({
        academicYearId: this.model.search.filters.academicYear?.id,
      }).then((res) => {
        this.model.search.collections.providers = res.data

        if (res.data.length === 1) {
          this.model.search.filters.provider = res.data[0]
          this.getSpecialist()
        }
      })
    },
    async onHandlerSearch() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate()
      if (isValid) {
        await this.process()
      }
    },
    async process() {
      if (this.hasValue(this.model.search.filters.academicYear?.id)
        && this.hasValue(this.model.search.filters.month?.id)) {
        await ReportServices.getReport('eligiblestudentsbyentity', {
          academicYearId: this.model.search.filters.academicYear.id,
          companyId: this.model.search.filters.provider?.id,
          month: this.model.search.filters.month?.id,
          determinationTypeId: this.model.search.filters.determinationType?.id,
        }).then((res) => DocumentServices.Download(res.data))
      }
    },
    async getMonthsInAcademicYear() {
      this.model.search.collections.months = (
        await AcademicYearServices.getMonthsInAcademicYear(
          this.model.search.filters.academicYear.id
        )
      ).data
    },
  },
}
</script>

<style lang="scss" scoped></style>
